/*
 * Copyright Mimic Networks, Inc. 2025.
 */

import { StateCreator } from 'zustand';

import type { MgmtPlaneState } from './mgmtPlaneStore';

export interface SubtenantsHierarchySlice {
  expandedKeys: string[];
  setExpandedKeys: (expandedKeys: string[]) => void;
}

export const createSubtenantsHierarchySlice: StateCreator<MgmtPlaneState, [], [], SubtenantsHierarchySlice> = (
  set,
) => ({
  expandedKeys: [],
  setExpandedKeys: (expandedKeys: string[]) => set(() => ({ expandedKeys })),
});
